// Componente per l'header dell'applicazione

import React from 'react';
import { useAppContext } from '../../context/AppContext';
import ProfileSwitcher from '../ProfileSwitcher';
import './Header.css';

interface HeaderProps {
    onLogout: () => void;
}

const Header: React.FC<HeaderProps> = ({ onLogout }) => {
    const { state } = useAppContext();

    return (
        <header className="header">
            <h1 className="header-title">ReCUP Manager</h1>
            <div className="header-center">
                <ProfileSwitcher compact />
            </div>
            <div className="header-user">
                {state.user && (
                    <span className="user-name">
                        Benvenuto, {state.user.username}
                    </span>
                )}
                <button className="logout-button" onClick={onLogout}>
                    Esci
                </button>
            </div>
        </header>
    );
};

export default Header;
